module.exports = __webpack_public_path__ + "static/media/ODS12.0043bb77.svg";